export default "__VITE_ASSET__C$Wkj3Iy__"